import { action, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

import { equalsDeep } from '../../../shared/equalsDeep';
import type { TUserData } from '../../../shared/types';
import type { TRecommendationRowData } from '../types';

export type TData = { [key: string]: unknown | null } & {
  [Key in keyof Partial<TRecommendationRowData>]: TRecommendationRowData[Key] | null;
};

export class Recommendation {
  readonly entityId = v4();
  readonly id: string | null;
  readonly initialData: TData;
  readonly userData: TUserData;

  dirty = false;

  data: TData;

  constructor(initialData: TData, userData: TUserData) {
    this.data = initialData;
    this.initialData = initialData;
    this.id = initialData.id ?? null;
    this.userData = userData;

    makeObservable(this, {
      data: observable,
      updateData: action,
    });
  }

  updateData(updateData: Partial<TData>): void {
    this.data = {
      ...this.data,
      ...updateData,
    };
    this.dirty = true;
  }

  get isChanged(): boolean {
    return this.dirty && !equalsDeep(this.data, this.initialData);
  }

  static hasContext(entity: Recommendation): boolean {
    const d = entity.data;
    return Boolean(
      (d.stageIds?.length ?? 0) ||
      (d.wellboreTypeIds?.length ?? 0) ||
      (d.trajectoryTypeIds?.length ?? 0) ||
      (d.sectionTypeIds?.length ?? 0) ||
      (d.holeTypes?.length ?? 0) ||
      (d.stratUnitTypeIds?.length ?? 0) ||
      (d.reservoirIds?.length ?? 0) ||
      (d.runTypeIds?.length ?? 0) ||
      (d.operationIds?.length ?? 0),
    );
  }
}
